import { useCurrencyStore } from '@/store/useCurrencyStore';

const currencySymbol = (currency?: string) => {
    switch (currency) {
        case 'USD':
            return '$';
        case 'EUR':
            return '€';
        case 'GBP':
            return '£';
        case 'JPY':
            return '¥';
        default:
            return '₾'; // Default to Georgian Lari
    }
};

const renderCurrencyAmount = (currency?: string, amount?: number) => {
    let currencyPresentation = '₾';
    if (currency === 'USD') {
        currencyPresentation = '$';
    }

    if (amount === undefined || amount === null) {
        return `0.00 ${currencyPresentation}`;
    }

    return `${amount.toFixed(2)} ${currencyPresentation}`;
};

const formatValueConfig = (value: number) => {
    switch (true) {
        case value > 0:
            return {
                colorClass: 'text-success-1000',
                sign: '+',
            };
        case value < 0:
            return {
                colorClass: 'text-error-1000',
                sign: '',
            };
        default:
            return {
                colorClass: 'text-popover-1000',
                sign: '',
            };
    }
};

const formatValue = (value?: number | string) => {
    const { currentCurrency, currencies } = useCurrencyStore();

    if (typeof value === 'number') {
        const { sign, colorClass } = formatValueConfig(value);

        return (
            <span className={colorClass}>{`${sign ?? ''}${value.toFixed(2)} ${
                currentCurrency && currencies[currentCurrency]
            }`}</span>
        );
    }

    if (value === 'free') {
        return <span className="text-success-1000">Free</span>;
    }

    return <span className="text-popover-1000">Free</span>;
};

const formatValueWithoutStyling = (value: number | string) => {
    const { currentCurrency, currencies } = useCurrencyStore();

    if (typeof value === 'number') {
        return (
            <span>{`${value.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })} ${currentCurrency && currencies[currentCurrency]}`}</span>
        );
    }

    if (value === 'free') {
        return <span className="text-success-1000">Free</span>;
    }

    return null;
};

const getMinMaxValues = (range?: string | null) => {
    const normalizedRange = range?.replace('+', '-') ?? '';
    const [min = '', max = ''] = normalizedRange.split('-');
    return { min, max };
};

export const NumbersHelper = {
    formatValue,
    formatValueConfig,
    formatValueWithoutStyling,
    getMinMaxValues,
    currencySymbol,
};
